import { useQuery, QueryHookOptions } from '@apollo/client';

import { useApolloClientForAspirex } from '@frontend/applications/AffiliatesApp/hooks/useApolloClientForAspirex';
import { GET_MEMBERS_FOR_IDS_QUERY } from '../queries';
import { GetMembersForIdsQuery, GetMembersForIdsQueryVariables } from '../queries/types/GetMembersForIdsQuery';

type IOptions = QueryHookOptions<GetMembersForIdsQuery, GetMembersForIdsQueryVariables>;

export const useGetMembersByIdsQuery = (memberIds: number[], options: IOptions = {}) => {
  const client = useApolloClientForAspirex();

  // Filter out any invalid IDs to prevent GraphQL validation errors
  const validMemberIds = memberIds?.filter((id): id is number =>
    Number.isInteger(id)
  ) || [];

  return useQuery<GetMembersForIdsQuery, GetMembersForIdsQueryVariables>(GET_MEMBERS_FOR_IDS_QUERY, {
    ...options,
    client,
    variables: {
      ids: validMemberIds,
    },
    skip: !validMemberIds.length || options.skip,
  });
};
